import { Dropdown } from 'react-bootstrap'
import { DropdownButton } from 'react-bootstrap'

export default function PageSizeSelector({pageSizeSignal, handlePageSizeSelect}) {
    return (
        <DropdownButton size="sm" variant="outline-secondary" title={`${pageSizeSignal} records per page`} id="pageSize-dropdown" onSelect={handlePageSizeSelect}>
            <Dropdown.Item eventKey="10">10</Dropdown.Item>
            <Dropdown.Item eventKey="25">25</Dropdown.Item>
            <Dropdown.Item eventKey="50">50</Dropdown.Item>
            <Dropdown.Item eventKey="250">250</Dropdown.Item>
            <Dropdown.Item eventKey="500">500</Dropdown.Item>
            <Dropdown.Item eventKey="1000">1000</Dropdown.Item>
        </DropdownButton>
    )
}

